import config from '../config';
import { request } from '../utils/request';

const systemDomain = `${config.host}${config.apiRouter.system}`;

const api = {
  getSystemList (data) {
    return request({
      method: 'POST',
      url: `${systemDomain}/GetSystemList`,
      data,
    });
  },
  createSystem (data) {
    return request({
      method: 'POST',
      url: `${systemDomain}/CreateSystem`,
      data,
    });
  },
  updateSystem (data) {
    return request({
      method: 'POST',
      url: `${systemDomain}/UpdateSystem`,
      data,
    });
  },
};
export default api;
